export const TID = {
  header: {
    root: "site-header",
    logo: "header-logo",
    navLink: (k) => `nav-link-${k}`,
    loginCta: "header-login-cta",
    mobileToggle: "mobile-menu-toggle",
    mobileMenu: "mobile-menu",
  },
  hero: {
    root: "hero-section",
    ctaPortal: "hero-cta-portal",
    ctaKonfigurator: "hero-cta-konfigurator",
  },
  stats: { root: "stats-section" },
  vehicles: { root: "vehicles-section", card: (k) => `vehicle-card-${k}` },
  services: { root: "services-section", card: (k) => `service-card-${k}` },
  manifesto: { root: "manifesto-section" },
  konfigurator: { root: "konfigurator-section", iframe: "konfigurator-iframe", open: "konfigurator-open" },
  faq: { root: "faq-section", item: (k) => `faq-item-${k}` },
  contact: {
    root: "contact-section",
    whatsapp: "contact-whatsapp",
    email: "contact-email",
    form: "contact-form",
    name: "contact-input-name",
    emailField: "contact-input-email",
    vehicle: "contact-select-vehicle",
    message: "contact-input-message",
    submit: "contact-submit",
  },
  footer: {
    root: "site-footer",
    portal: "footer-portal-link",
    filesuite: "footer-filesuite-link",
    drcoding: "footer-drcoding-link",
    impressum: "footer-impressum-link",
    datenschutz: "footer-datenschutz-link",
  },
};
